import { render, staticRenderFns } from "./SettingDateTime.vue?vue&type=template&id=670652ee&scoped=true"
import script from "./SettingDateTime.vue?vue&type=script&lang=js"
export * from "./SettingDateTime.vue?vue&type=script&lang=js"
import style0 from "./SettingDateTime.vue?vue&type=style&index=0&id=670652ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670652ee",
  null
  
)

export default component.exports